"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelectPopupTestIds = void 0;
let LanguageSelectPopupTestIds = exports.LanguageSelectPopupTestIds = /*#__PURE__*/function (LanguageSelectPopupTestIds) {
  LanguageSelectPopupTestIds["LIST"] = "language-select-popup-list";
  LanguageSelectPopupTestIds["LIST_ITEM"] = "language-select-popup-list-item";
  LanguageSelectPopupTestIds["ROOT"] = "language-select-popup-root";
  return LanguageSelectPopupTestIds;
}({});
